import { Validator } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import moment from './moment'

Validator.addLocale(ptBR)
Validator.setLocale('pt_BR')

Validator.extend('date_valid', {
    getMessage: field => `O campo ${field} não possui uma data válida.`,
    validate: value => new Promise(resolve => {
        let isValid = moment(value, 'DD/MM/YYYY', true).isValid();

        resolve({
            valid: value && isValid
        });
    })
})


// WEBPACK FOOTER //
// ./src/shared/helpers/validator.js